import { useState } from "react";
import { useTranslation } from "react-i18next";
import ChartBedwetting from "./chart-bedwetting";
import "./styles.scss";
import ChartTemperature from "./chart-temperature";

const GraphUrine = ({ dateSelected, setDateSelected, patientId, treatmentDate }) => {
  const { t } = useTranslation();
  const [chartMode, setChartMode] = useState(true);

  return (
    <div className="chart-urine-container">
      <div className="chart-switch-sesstion">
        <div
          className={`chart-button ${chartMode ? "chart-button-active" : ""}`}
          onClick={() => {
            setChartMode(true);
          }}
        >
          {t("graph.bedwetting")}
        </div>
        <div
          className={`chart-button ${!chartMode ? "chart-button-active" : ""}`}
          onClick={() => {
            setChartMode(false);
          }}
        >
          {t("graph.temperaturePosition")}
        </div>
      </div>
      {chartMode ? (
        <ChartBedwetting patientId={patientId} treatmentDate={treatmentDate}/>
      ) : (
        <ChartTemperature patientId={patientId} dateSelected={dateSelected} setDateSelected={setDateSelected} />
      )}
    </div>
  );
};

export default GraphUrine;
